import { Transaction } from './serialization/transaction';
import { Ed25519HdKey, Ed25519Key, CardanoKey } from "./lib/crypto/ed25519.browser";
import { Ed25519HdKeyAsync, Ed25519KeyAsync, CardanoKeyAsync } from "./lib/crypto/ed25519-async";
import { bech32 } from "./lib/bech32";
import { blake } from "./lib/blake";
import { cip8Sign, Cip8SignResult, CoseSign1, CoseSignResult,AlgorithmId, CoseKey, KeyType } from "./cip8";
import {
  ShelleyAddress,
  Address,
  StakeAddress,
  Credential,
  StakeCredential, DrepCredential,
} from "./serialization/address";
import { Value } from "./serialization/value";
import { Block, BlockHeader } from './serialization/block';
import { RawTransaction } from './serialization/cddlTypes';
import {
  Script,
  PlutusScript,
  NativeScript,
  NativeScriptType,
  ScriptAll,
  ScriptAny,
  ScriptInvalidBefore,
  ScriptInvalidHereafter,
  ScriptNofK,
} from "./serialization/plutusScript";
import { ScriptPubKey } from './serialization/script';
import { NativeScriptJSON } from './serialization';

const blake2b = blake;
const loadCrypto = async () => {};
export type DrepAddress = DrepCredential
export {
  // crypto
  loadCrypto,
  Ed25519HdKey,
  Ed25519Key,
  CardanoKey,
  Ed25519HdKeyAsync,
  Ed25519KeyAsync,
  CardanoKeyAsync,

  BlockHeader,
  Block,

  RawTransaction,
  Transaction,

  // credential and address
  Credential,
  DrepCredential,
  StakeCredential,
  Address,
  StakeAddress,
  ShelleyAddress,

  // types
  Value,

  // Scripts
  Script,
  PlutusScript,
  NativeScript,
  NativeScriptJSON,
  ScriptPubKey,
  ScriptAll,
  ScriptAny,
  ScriptNofK,
  ScriptInvalidBefore,
  ScriptInvalidHereafter,
  NativeScriptType,

  // encoding and hashes
  blake,
  blake2b,
  bech32,

  // cip 8
  AlgorithmId,
  KeyType,
  cip8Sign,
  CoseSign1,
  CoseKey,
  CoseSignResult,
  Cip8SignResult

};

